const GoogleIcon = () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="google-icon-logo-svgrepo-com 1" clipPath="url(#clip0_235_5964)">
      <path
        id="Vector"
        d="M23.7141 12.2245C23.7141 11.2413 23.6343 10.5238 23.4616 9.77966H12.2336V14.2176H18.8242C18.6914 15.3205 17.9739 16.9815 16.3793 18.0976L16.357 18.2462L19.907 20.9964L20.153 21.0209C22.4118 18.9347 23.7141 15.8653 23.7141 12.2245Z"
        fill="#4285F4"
      />
      <path
        id="Vector_2"
        d="M12.2336 23.9176C15.4624 23.9176 18.1731 22.8545 20.153 21.0209L16.3793 18.0976C15.3695 18.8018 14.0141 19.2934 12.2336 19.2934C9.07121 19.2934 6.38715 17.2074 5.43035 14.324L5.29011 14.3359L1.59869 17.1927L1.55042 17.3269C3.51695 21.2334 7.55637 23.9176 12.2336 23.9176Z"
        fill="#34A853"
      />
      <path
        id="Vector_3"
        d="M5.43029 14.324C5.17783 13.5799 5.03173 12.7826 5.03173 11.9588C5.03173 11.1349 5.17783 10.3377 5.41701 9.5936L5.41032 9.43513L1.67264 6.53241L1.55035 6.59058C0.739849 8.21168 0.27478 10.0321 0.27478 11.9588C0.27478 13.8855 0.739849 15.7058 1.55035 17.3269L5.43029 14.324Z"
        fill="#FBBC05"
      />
      <path
        id="Vector_4"
        d="M12.2336 4.62403C14.4792 4.62403 15.9939 5.59402 16.8577 6.40461L20.2327 3.10928C18.1599 1.1826 15.4624 0 12.2336 0C7.55637 0 3.51695 2.68406 1.55042 6.59056L5.41707 9.59359C6.38715 6.7102 9.07121 4.62403 12.2336 4.62403Z"
        fill="#EB4335"
      />
    </g>
    <defs>
      <clipPath id="clip0_235_5964">
        <rect fill="white" height="24" width="24" />
      </clipPath>
    </defs>
  </svg>
)

export default GoogleIcon
